import React, { useEffect, useState } from 'react'
import { arrayOf } from '../../../../utils/StoreUtils'
import i18n from 'simple-react-i18n'
import Select from '../../../../components/forms/Select'
import { getIntegrationModesOpenData } from '../../../../utils/JobUtils'
import PropTypes from 'prop-types'
import Job from '../../../dto/DtoJob'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import CityDto from '../../../../referencial/components/city/dto/CityDto'
import Button from '../../../../components/forms/Button'
import CityAction from '../../../../referencial/components/city/actions/CityAction'
import Checkbox from '../../../../components/forms/Checkbox'
import SelectionTableModal from '../../../../components/modal/SelectionTableModal'
import { normalizeString } from '../../../../utils/StringUtil'
import { Grid } from '@mui/material'
import { SimpleFilterField } from '../../../../components/datatable/SimpleSelectionTable'
import IntegrationModeDialog from '../IntegrationModeDialog'
import RadioButtons from '../../../../components/forms/RadioButtons'
import { CardTable } from '../../../../components/datatable/NewTable'
import { exportFile } from '../../../../utils/ExportDataUtil'
import Input from '../../../../components/forms/Input'
import { DATA_ADD_LAST_DATA } from '../../../../traitements/constants/TraitementConstants'
import { StyledFieldSet, StyledLegend } from 'components/StyledElements'

const CITY = 'CITY'
const STATIONS = 'STATIONS'
const DEPARTMENTS = 'DEPARTMENTS'

const MeteoFranceRadarPanel = ({
    isEditMode,
    onChangeFilters,
    filters = {},
}) => {
    const [cityPopupOpen, setCityPopupOpen] = useState(false)
    const [tmpCode, setTmpCode] = useState('')
    const dispatch = useDispatch()

    const {
        cities,
    } = useSelector(store => ({
        cities: store.CityReducer.cities,
    }), shallowEqual)

    useEffect(() => {
        if (!cities.length) {
            dispatch(CityAction.fetchCities())
        }
        if (!Object.keys(filters).length) {
            onChangeFilters({
                importMode: DATA_ADD_LAST_DATA,
                cities: [],
                stations: [],
                departments: [],
                rain: true,
                etp: true,
                radiation: true,
                temperature: true,
                stationsMode: CITY,
            })
        }
    }, [])

    const disabled = !isEditMode
    const codesTypes = [
        { code: STATIONS, name: i18n.stations },
        { code: CITY, name: i18n.cities },
        { code: DEPARTMENTS, name: i18n.departments },
    ]

    const codes = () => {
        if (filters.stationsMode === DEPARTMENTS) {
            return (filters.departments ?? []).map(code => ({ code }))
        } else if (filters.stationsMode === STATIONS) {
            return (filters.stations ?? []).map(code => ({ code }))
        }
        return (filters.cities ?? []).map(code => ({ code }))
    }
    return (
        <>
            <Grid container rowSpacing={1} spacing={1}>
                <Grid size={4}>
                    <StyledFieldSet>
                        <StyledLegend>{ i18n.datas }</StyledLegend>
                        <Grid container rowSpacing={1} spacing={1} alignItems='center' justifyContent='center'>
                            <Grid size={8}>
                                <Select
                                    options={ getIntegrationModesOpenData() }
                                    obligatory
                                    label={ i18n.dataIntegration }
                                    value={ filters.importMode }
                                    labelSpan={ <IntegrationModeDialog /> }
                                    onChange={ v => onChangeFilters({ importMode: v }) }
                                    disabled={ disabled }
                                />
                            </Grid>
                            <Grid container size={6}>
                                <Grid size={12}>
                                    <Checkbox
                                        label={i18n.rain}
                                        checked={filters.rain}
                                        onChange={c => onChangeFilters({ rain: c })}
                                        disabled={ disabled }
                                    />
                                </Grid>
                                <Grid size={12}>
                                    <Checkbox
                                        label={i18n.radiation}
                                        checked={filters.radiation}
                                        onChange={c => onChangeFilters({ radiation: c })}
                                        disabled={ disabled }
                                    />
                                </Grid>
                                <Grid size={12}>
                                    <Checkbox
                                        label={i18n.etp}
                                        checked={filters.etp}
                                        onChange={c => onChangeFilters({ etp: c })}
                                        disabled={ disabled }
                                    />
                                </Grid>
                                <Grid size={12}>
                                    <Checkbox
                                        label='ETR'
                                        checked={filters.etr}
                                        onChange={c => onChangeFilters({ etr: c })}
                                        disabled={ disabled }
                                    />
                                </Grid>
                                <Grid size={12}>
                                    <Checkbox
                                        label='Humidité'
                                        checked={filters.humidity}
                                        onChange={c => onChangeFilters({ humidity: c })}
                                        disabled={ disabled }
                                    />
                                </Grid>
                                <Grid size={12}>
                                    <Checkbox
                                        label='Humidité du sol (SWI)'
                                        checked={filters.soilHumidity}
                                        onChange={c => onChangeFilters({ soilHumidity: c })}
                                        disabled={ disabled }
                                    />
                                </Grid>
                                <Grid size={12}>
                                    <Checkbox
                                        label='Humidité spécifique'
                                        checked={filters.humiditySpe}
                                        onChange={c => onChangeFilters({ humiditySpe: c })}
                                        disabled={ disabled }
                                    />
                                </Grid>
                            </Grid>
                            <Grid container size={6}>
                                <Grid size={12}>
                                    <Checkbox
                                        label={i18n.temperature}
                                        checked={filters.temperature}
                                        onChange={c => onChangeFilters({ temperature: c })}
                                        disabled={ disabled }
                                    />
                                </Grid>
                                <Grid size={12}>
                                    <Checkbox
                                        label={`${i18n.temperature} Min`}
                                        checked={filters.temperatureMin}
                                        onChange={c => onChangeFilters({ temperatureMin: c })}
                                        disabled={ disabled }
                                    />
                                </Grid>
                                <Grid size={12}>
                                    <Checkbox
                                        label={`${i18n.temperature} Max`}
                                        checked={filters.temperatureMax}
                                        onChange={c => onChangeFilters({ temperatureMax: c })}
                                        disabled={ disabled }
                                    />
                                </Grid>
                                <Grid size={12}>
                                    <Checkbox
                                        label='Vent'
                                        checked={filters.wind}
                                        onChange={c => onChangeFilters({ wind: c })}
                                        disabled={ disabled }
                                    />
                                </Grid>
                                <Grid size={12}>
                                    <Checkbox
                                        label='Drainage'
                                        checked={filters.drain}
                                        onChange={c => onChangeFilters({ drain: c })}
                                        disabled={ disabled }
                                    />
                                </Grid>
                                <Grid size={12}>
                                    <Checkbox
                                        label='Ruissellement'
                                        checked={filters.runoff}
                                        onChange={c => onChangeFilters({ runoff: c })}
                                        disabled={ disabled }
                                    />
                                </Grid>
                                <Grid size={12}>
                                    <Checkbox
                                        label={i18n.snow}
                                        checked={filters.snow}
                                        onChange={c => onChangeFilters({ snow: c })}
                                        disabled={ disabled }
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </StyledFieldSet>
                </Grid>
                <Grid size={4}>
                    <StyledFieldSet>
                        <StyledLegend>{ i18n.previData }</StyledLegend>
                        <Grid container rowSpacing={1} alignItems='center' justifyContent='center'>
                            <Grid size={12}>
                                <Checkbox
                                    label='Importer les données de prévisions AROME (3 jours)'
                                    checked={filters.addAROMEdata}
                                    onChange={c => onChangeFilters({ addAROMEdata: c })}
                                    disabled={ disabled }
                                />
                            </Grid>
                            <Grid size={12}>
                                <Checkbox
                                    label='Importer les données de prévisions ARPEGE (5 jours)'
                                    checked={filters.addARPEGEdata}
                                    onChange={c => onChangeFilters({ addARPEGEdata: c })}
                                    disabled={ disabled }
                                />
                            </Grid>
                            <Grid size={12}>
                                <Checkbox
                                    label='Importer les données de prévisions ECMWF (15 jours)'
                                    checked={filters.addECMWFdata}
                                    onChange={c => onChangeFilters({ addECMWFdata: c })}
                                    disabled={ disabled }
                                />
                            </Grid>
                            <Grid size={12}>
                                <Checkbox
                                    label='Importer les seeds ECMWF (utilisé pour la modélisation)'
                                    checked={filters.addECMWFSeedsdata}
                                    onChange={c => onChangeFilters({ addECMWFSeedsdata: c })}
                                    disabled={ disabled }
                                />
                            </Grid>
                        </Grid>
                    </StyledFieldSet>
                </Grid>
                <Grid size={4}>
                    <RadioButtons
                        elements={codesTypes}
                        selected={filters.stationsMode}
                        onChange={v => onChangeFilters({ stationsMode: v })}
                        disabled={!isEditMode}
                        title={i18n.schemeAgencyID}
                    />
                    {
                        (filters.stationsMode === STATIONS || filters.stationsMode === DEPARTMENTS) &&(
                            <Grid container alignItems='center' justifyContent='center' spacing={1}>
                                <Grid size={8}>
                                    <Input
                                        value={tmpCode}
                                        onChange={setTmpCode}
                                        title='code'
                                        disabled={!isEditMode}
                                    />
                                </Grid>
                                <Grid size={4}>
                                    <Button title={i18n.add} onClick={() => {
                                        if (tmpCode.length && filters.stationsMode === DEPARTMENTS) {
                                            onChangeFilters({ departments: [...filters.departments, tmpCode] })
                                            setTmpCode('')
                                        } else if (tmpCode.length) {
                                            onChangeFilters({ stations: [...filters.stations, tmpCode] })
                                            setTmpCode('')
                                        }
                                    }} disabled={!isEditMode}
                                    />
                                </Grid>
                                <Grid size={12}>
                                    <CardTable
                                        headers={['code']}
                                        rows={codes()}
                                        title={i18n.credentials}
                                        lineActions={[
                                            { icon: 'delete', onClick: ({ code }) => {
                                                if (filters.stationsMode === DEPARTMENTS) {
                                                    onChangeFilters({ departments: filters.departments.filter(s => s !== code) })
                                                } else {
                                                    onChangeFilters({ stations: filters.stations.filter(s => s !== code) })
                                                }
                                            }, displayed: isEditMode },
                                        ]}
                                        actions={[{
                                            icon: 'download',
                                            onClick: () => exportFile({
                                                data: [{ ...(codes()[0]), headers: ['code'] }, ...(codes().slice(1, codes().length))],
                                                titleFile: i18n.credentials,
                                            }),
                                            tooltip: i18n.download,
                                        }]}
                                        displayHeaders={false}
                                    />
                                </Grid>
                            </Grid>
                        )
                    }
                    {
                        filters.stationsMode === CITY && (
                            <StyledFieldSet>
                                <StyledLegend>{ i18n.cities }</StyledLegend>
                                <Button
                                    title={ `${(filters.cities || []).length} ${i18n.cities}` }
                                    onClick={ () => setCityPopupOpen(true) }
                                    disabled={ disabled }
                                />
                            </StyledFieldSet>
                        )
                    }
                </Grid>
            </Grid>
            <SelectionTableModal
                isOpen={cityPopupOpen}
                onClose={() => setCityPopupOpen(false)}
                onValidate={list => {
                    onChangeFilters({ cities: list })
                    setCityPopupOpen(false)
                }}
                title={i18n.cities}

                listData={cities}
                defaultSelectionList={filters.cities ?? []}

                listHeaders={['code', 'name']}
                listTitle={i18n.cities}
                selectionListTitle={i18n.selectedElements}
                maxHeightTable={'48vh'}


                filterField={SimpleFilterField}
                filterFunction={(list, { searchValue }) => {
                    const searchValueFormat = normalizeString(searchValue)
                    return searchValue ? list.filter(p => normalizeString([p.code, p.name].join('   ')).includes(searchValueFormat)) : list
                }}
            />
        </>
    )
}

MeteoFranceRadarPanel.propTypes = {
    job: PropTypes.instanceOf(Job).isRequired,
    onChangeFilters: PropTypes.func.isRequired,
    isEditMode: PropTypes.bool,
    cities: arrayOf(CityDto),
    filters: PropTypes.shape({}),
}

export default MeteoFranceRadarPanel